<!--  -->
<template>
	<div class="content">
		<cx-head v-if="windowWidth <= 768" />
		<b-container fluid>
			<img class="top_img" width="100%" src="../../static/img/about/top_img.png" />
			<img class="top_img1" width="100%" src="../../static/img/about/top_img1.png" />
		</b-container>
		<div class="mianbao" toggleable="lg" :class="{ isFixed: isFixed }" ref="obtain">
			<div class="mianbao_view">
				<div v-for="(item, index) in mianbaoList" :key="index" class="mianbao_item"
					@click="goAnchor(item.id, index)" :class="{ active: index == tabCur }">{{ item.label }}</div>
			</div>
			<div class="mianbao_min">
				<div style="width: 90px;" v-for="(item, index) in mianbaoList1" :key="index" :class="{ active: index == tabCur }"
					@click="goAnchor(item.id, index)">{{ item.label }}</div>
			</div>
		</div>

		<div class="about_view" id="title1">
			<h4 class="title_text">公司简介</h4>
			<p class="about_text">
				湖南快乐车行露营地投资发展有限公司是全国工商联汽车经销商商会房车露营专委会会长单位，已获得高新技术企业认定。公司拥有一站式房车旅游综合服务平台“约你游”， 平台上的自建及合作营地遍布全国，自行式房车和营地房车数百台。其中，近800亩房车露营示范营地——约你游（长沙）房车露营飞行基地被国家体育总局中汽摩联授予“五星级汽车自驾运动营地”。公司承办中部（长沙）房车露营博览会等多场行业大会，出席参会数十场，各地组织房车游活动上百场，是国内房车旅游行业综合实力排在前列的企业之一。
				<br />
				<br />
				未来，公司将紧抓行业机遇，以全球景区为合作对象，以物联网、大数据、人工智能、新能源房车、无人驾驶等技术为依托，通过“房车+” “营地+”等模式，与更多相关产业生态做有效的连接与融合，以线上线下一体化发展的房车运营体系形成叠加的经济效应，助力推动着我国房旅产业智能化、社交化、共享化发展，成为全球房旅行业独角兽企业。
			</p>
		</div>
		<div class="vision_view" id="title2">
			<img style="object-fit: cover" src="../../static/img/about/top2.png" />
		</div>
		<div class="vision_view1" id="title2">
			<img style="object-fit: cover" src="../../static/img/about/top21.png" />
		</div>
		<div class="history_view" id="title3">
			<h4 class="title_text" style="color: #fff !important;">发展历程</h4>
			<div class="year_view">
				<div class="year_item" style="z-index: 2;" v-for="(item, index) in historyData" :key="index"
					@click="yearCur=index">
					<div class="">{{ item.Year }}</div>
					<img style="margin-top: 10px;z-index: 3;" width="24" height="24"
						:src="yearCur==index? '../../static/img/about/ic_quan.png':'../../static/img/about/ic_quan2.png'" />
				</div>
				<div class="xian"></div>
			</div>
			<div class="content_list">
				<div class="content_xq">
					<div class="content_item" v-for="(item1, index1) in historyData[yearCur].Data" :key="index1">
						<!-- <div class="month" style="width:35px">{{  dateFormort(item1.Date).getMonth() + 1 }}月</div> -->
						<div class="month" style="width:70px">{{ formatDate(item1.Date) }}</div>
						<div class="content_text">{{ item1.Content }}</div>
					</div>
				</div>
			</div>

		</div>
		<div class="about_view" id="title4">
			<h4 class="title_text" style="text-align: left;margin-left: 20px;">管理团队</h4>
			<div class="manageTeam">
				<div class="manage_item" v-for="(item, index) in TeamData" :key="index">
					<img class="teamImg" :src="item.Photo" />
					<div class="manageName">{{ item.Name }}</div>
					<div class="manageJob">{{ item.JobDescription }}</div>
				</div>
			</div>
		</div>
		<div class="honor_view" id="title5">
			<div style="max-width: 1440px;margin: 0 auto;">
				<h4 class="title_text" style="text-align: left;">企业荣誉</h4>
				<div class="honorList" v-if="windowWidth > 768">
					<div class="honor_item" v-for="(item, index) in HonorsData" :key="index">
						<img class="honorImg" :src="item.Image" />
						<p class="honorText">{{ item.Title }}</p>
					</div>
				</div>
				<Swiper class="my-swipe swiper honorList" :options="swiperOption1" v-else>
					<swiper-slide class="honor_item" v-for="(item, index) in HonorsData" :key="index">
						<img class="honorImg" :src="item.Image" />
						<p class="honorText">{{ item.Title }}</p>
					</swiper-slide>
				</Swiper>
			</div>
		</div>
		<div class="live_view" id="title6" style="margin-top: 40px;">
			<h4 class="title_text">线上参观</h4>
			<div class="live_box">
				<div class="live_item" @click="goto('https://www.720yuntu.com/tour/22b4d67cf7430d46')">
					<img class="live_img" width="100%" :height="windowWidth>768?660:277"
						src="../../static/img/about/view1.png" />
					<img class="point" :width="windowWidth>768?190:95" :height="windowWidth>768?82:41" src="../../static/img/about/point1.png" />
				</div>
				<div class="live_item" @click="goto('https://www.720yuntu.com/tour/6eca27b40e5ced50')">
					<img class="live_img" width="100%" :height="windowWidth>768?660:277"
						src="../../static/img/about/view2.png" />
					<img class="point" :width="windowWidth>768?190:95" :height="windowWidth>768?82:41" src="../../static/img/about/point2.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	import api from '../api/api.js';
	import cxHead from '@/components/cx-head.vue';
	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {
			cxHead,
		},
		metaInfo() {
			return {
				title: this.pageName, // set a title
				meta: [
					{
						// set meta
						name: 'keyWords',
						content: this.SeoKeyword,
					},
					{
						name: 'description',
						content: this.SeoDescription,
					},
				],
			};
		},
		data() {
			//这里存放数据
			return {
				isFixed: false,
				windowWidth: window.innerWidth,
				pageName: '',
				SeoKeyword: '',
				SeoDescription: '',
				tabCur: 0,
				mianbaoList: [
					{
						label: '公司简介',
						path: '#',
						id: '#title1',
					},
					{
						label: '愿景及使命',
						path: '#',
						id: '#title2',
					},
					{
						label: '发展历程',
						path: '#',
						id: '#title3',
					},
					{
						label: '管理团队',
						path: '#',
						id: '#title4',
					},
					{
						label: '企业荣誉',
						path: '#',
						id: '#title5',
					},
					{
						label: '线上参观',
						path: '#',
						id: '#title6',
					},
				],
				mianbaoList1: [
					{
						label: '公司简介',
						path: '#',
						id: '#title1',
					},
					{
						label: '愿景及使命',
						path: '#',
						id: '#title2',
					},
					{
						label: '发展历程',
						path: '#',
						id: '#title3',
					},
					{
						label: '管理团队',
						path: '#',
						id: '#title4',
					},
					{
						label: '企业荣誉',
						path: '#',
						id: '#title5',
					},
					{
						label: '线上参观',
						path: '#',
						id: '#title6',
					}
				],
				yearCur: 0,
				historyData: [],//发展历程
				TeamData: [],//管理团队
				HonorsData: [],//荣誉证书
				swiperOption: {
					// autoplay: {
					// 	disableOnInteraction: false,
					// 	delay: 500,
					// },
					slidesPerView: window.innerWidth >= 768 ? 5 : 1.3,
					spaceBetween: window.innerWidth >= 768 ? 76 : 10,
					slidesOffsetBefore: window.innerWidth >= 768 ? 240 : 20,
					grabCursor: true,
					// slidesPerView: 1,
					// loop: true,
					// width: 1040,
					// navigation: {
					// 	nextEl: '.swiper-button-next',
					// 	prevEl: '.swiper-button-prev',
					// },
					// pagination: {
					// 	el: ".swiper-pagination",
					// 	type: "fraction",
					// },
				},
				swiperOption1: {
					// autoplay: {
					// 	disableOnInteraction: false,
					// 	delay: 500,
					// },
					// grid: {
					// 	rows: 3,
					// },
					// slidesPerColumn: 3,
					slidesPerView: 2.1,
					spaceBetween: 10,
					slidesPerColumnFill: 'row',
					// height:690
					// slidesPerView: 1,
					// loop: true,
					// width: 1040,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					// pagination: {
					// 	el: ".swiper-pagination",
					// 	type: "fraction",
					// },
				},
			};
		},

		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {

			goto(e) {//跳转外部链接
				window.open(e, '_blank');
				// window.location.href = e;
			},

			Scroll(e) {
				let that = this;
				let scrollTop = e.target.documentElement.scrollTop || e.target.body.scrollTop;
				console.log(scrollTop);
				let mianbaoTop = that.$refs.obtain.getBoundingClientRect().top;
				console.log('距离顶部高度', mianbaoTop)
				if (scrollTop > 620 && that.windowWidth > 768) {
					that.isFixed = true;
					if (scrollTop < 1000) {
						that.tabCur = 0
					}
					else if (1000 <= scrollTop && scrollTop < 1400) {
						that.tabCur = 1
					}
					else if (1400 <= scrollTop && scrollTop < 2340) {
						that.tabCur = 2
					}
					else if (2340 <= scrollTop && scrollTop < 4800) {
						that.tabCur = 3
					} else if (4800 <= scrollTop && scrollTop < 5820) {
						that.tabCur = 4
					} else if (5820 <= scrollTop) {
						that.tabCur = 5
					}
				} else if(scrollTop > 300 && that.windowWidth <= 768) {
					that.isFixed = true;
				}else{
					that.isFixed = false;
				}
			},

			formatDate(date) { //格式化日期
				if (date) {
					let date1 = new Date(date.replace(/-/g, '/'));
					date = this.common.formatDate(new Date(date1), 'MM月dd日');
				}
				return date;
			},

			dateFormort(dateStart) {
				let date = new Date(dateStart.replace(/-/g, '/'));
				return date;
			},

			getSiteData() {
				//获取seo关键字
				let that = this;
				that.$axios
					.post(api.GetSiteData, {})
					.then(function (response) {
						// console.log('seo优化', response);
						let data = response.data;
						that.pageName = data.Title ? data.Title : '约你游·一站式房车旅游综合服务平台';
						that.SeoKeyword = data.SeoKeyword ? data.SeoKeyword : '约你游·一站式房车旅游综合服务平台';
						that.SeoDescription = data.SeoDescription
							? data.SeoDescription
							: '约你游·一站式房车旅游综合服务平台';
					})
					.catch(function (error) {
						console.log(error);
					});
			},
			goAnchor(selector, index) {
				// debugger
				this.tabCur = index;
				//跳转锚点
				var anchor = this.$el.querySelector(selector); // 参数为要跳转到的元素id
				document.body.scrollTop = anchor.offsetTop; // chrome
				document.documentElement.scrollTop = anchor.offsetTop; // firefox
			},

			getHistoryPageData() {//获取发展历程
				let that = this;
				this.$axios
					.post(api.GetHistoryPageData, { wheres: "[{ name: 'Type', value:'1' }]" })
					.then(function (response) {
						let data = response.data;
						that.historyData = data;
					})
					.catch(function (error) {
						console.log(error);
					});
			},
			getCompanyTeamData() {//获取管理团队
				let that = this;
				this.$axios
					.post(api.GetCompanyTeamData, { page: 1, rows: 99, sort: 'Sort,CreateDate' })
					.then(function (response) {
						let data = response.data.rows;
						that.TeamData = data;
					})
					.catch(function (error) {
						console.log(error);
					});
			},
			getCorporateHonorsData() {//获取荣誉证书
				let that = this;
				this.$axios
					.post(api.GetCorporateHonorsData, { page: 1, rows: 99, sort: 'Sort,CreateDate' })
					.then(function (response) {
						// debugger
						let data = response.data.rows;
						that.HonorsData = data;
					})
					.catch(function (error) {
						console.log(error);
					});
			},

		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {
			this.getHistoryPageData();
			this.getCompanyTeamData();
			this.getCorporateHonorsData();
		},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
			window.addEventListener('scroll', this.Scroll, true);
			this.getSiteData();
		},
		beforeCreate() { }, //生命周期 - 创建之前
		beforeMount() { }, //生命周期 - 挂载之前
		beforeUpdate() { }, //生命周期 - 更新之前
		updated() { }, //生命周期 - 更新之后
		beforeDestroy() { }, //生命周期 - 销毁之前
		destroyed() { }, //生命周期 - 销毁完成
		activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style lang='scss' scoped>
	//@import url(); 引入公共css类
	.content {
		padding-bottom: 90px;
	}

	.container-fluid {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.mianbao {
		background: #fbfbfb;
		font-size: 16px;
		// padding: 15px 0;
		padding-top: 15px;
	}

	.isFixed {
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 9999;
	}

	.mianbao_view {
		max-width: 1460px;
		width: 100%;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.content_text {
		flex: 1;
	}


	@media (min-width: 768px) {
		.mianbao_min {
			display: none;
		}

		.top_img1 {
			display: none;
		}

		.top_img {
			display: block;
		}


		.about_text {
			color: #222222;
			font-size: 1.1rem;
			line-height: 2.4;
			text-align: left;
			margin-top: 50px;
		}

		.manageTeam {
			max-width: 1440px;
			width: 100%;
			display: flex;
			list-style: none;
			// width: 970px;
			flex-wrap: wrap;
			margin: 0 auto;
			margin-top: 20px;
			padding: inherit;
			text-align: left;
			color: #222;

			.manage_item {
				width: 25%;
				// padding: 0 20px;
				margin-top: 20px;

				.teamImg {
					width: 330px;
					height: 330px;
				}

				.manageName {
					font-size: 24px;
					margin-top: 30px;
					font-weight: bold;
					font-family: 'zxhjt';
					font-style: oblique;
				}

				.manageJob {
					margin-top: 19px;

				}

				img {
					width: 100%;
					height: auto;
					border-radius: 10px;

				}
			}
		}

		.history_view {
			background: url('../../static/img/about/yearImg.png') no-repeat;
			width: 100%;
			height: auto;
			background-size: 100% auto;
			background-position: center center;
			padding: 70px 0;
			padding-top: 80px;
			padding-bottom: 124px;

			.year_view {
				flex-direction: row;
				display: flex;
				align-items: center;
				width: 100%;
				max-width: 900px;
				margin: 0 auto;
				color: #fff;
				margin-top: 60px;
				overflow-x: auto;
				justify-content: space-between;
				font-size: 16px;
				/* .year_item{
					margin: 0 40px;
					cursor: pointer;
				} */

			}

			.xian {
				width: 100%;
				max-width: 844px;
				height: 3px;
				background-color: rgba(239, 239, 239, 0.3);
				position: absolute;
				left: 50%;
				margin-left: -422px;
				margin-top: 33px;
				z-index: 1;
			}

			.content_list {
				color: #fff;
				width: 100%;
				max-width: 900px;
				border-radius: 10px;
				background: rgba(0, 0, 0, 0.4);
				height: 500px;
				/* overflow-y: auto; */
				padding: 55px 25px 55px 65px;
				margin: 0 auto;
				margin-top: 100px;

				.content_xq {
					height: 390px;
					overflow-y: auto;
				}

				.content_item {
					display: flex;
					flex-direction: row;
					text-align: left;
					margin-bottom: 40px;
					padding-right: 60px;
				}
			}
		}

		.honor_view {
			// background: url('../../static/img/about/gg_bg.png') no-repeat;
			width: 100%;
			height: auto;
			// background-size: 100% auto;
			background-position: center center;
			padding: 70px 0;
			// padding-top: 84px;
			// padding-bottom: 70px;
			margin-top: 80px;
			background-color: #fbfbfb;

			.honorList {
				display: flex;
				width: 100%;
				max-width: 1440px;
				flex-wrap: wrap;
				margin: 0 auto;
				// margin-top: 20px;
				padding: inherit;
				text-align: center;
				color: #222;
				// justify-content: space-between;
			}

			.honor_item {
				width: 246px;
				margin-top: 20px;
				margin-right: 104px;

				.honorText {
					margin-top: 19px;
				}

				.honorImg {
					width: 100%;
					height: 186px;
					margin-top: 40px;
					border: 2px solid #DAC870;
					padding: 3px;
				}

			}

		}

		.honorImg:nth-child(2n) {
			margin-left: 150px;
		}

		.live_view {
			.title_text {
				text-align: left;
				max-width: 1440px;
				margin: 0 auto;
			}
		}

		.live_box {
			display: flex;
			flex-direction: row;
			margin-top: 40px;

			.live_item {
				flex: 1;
				position: relative;

				.point {
					position: absolute;
					top: 50%;
					left: 50%;
					margin-left: -88px;
					margin-top: -31px;
					animation: zoom 1s infinite ease-in-out;
					-webkit-animation: zoom 1s infinite ease-in-out;
					cursor: pointer;
				}

				@keyframes zoom {
					0% {
						transform: scale(1);
					}

					50% {
						transform: scale(1.1);
					}

					100% {
						transform: scale(1);
					}
				}
			}
		}
	}

	@media (max-width: 768px) {
		.about_view {
			margin-top: 30px !important;
		}

		.mianbao_min {
			display: -webkit-box;
			height: 40px;
			line-height: 35px;
			background-color: #FBFBFB;
			width: 100%;
			/* justify-content: space-around; */
			text-align: center;
			font-size: 14px;
			overflow-x: auto;
		}

		.vision_view {
			display: none;
		}

		.vision_view1 {
			display: block;
			margin: 0 25px;
			margin-top: 30px;

			img {
				width: 100%
			}
		}

		#tt3 {
			display: none !important
		}

		.top_img {
			display: none;
		}

		.mianbao_item {
			flex: 1;
		}

		.mianbao {
			padding-top: 0;
		}

		.mianbao_view {
			display: none;
		}

		.about_text {
			color: #222222;
			font-size: 14px;
			padding: 0 15px;
			text-align: left;
			margin-top: 20px;
		}

		.manageTeam {
			// max-width: 1440px;
			width: 100%;
			display: flex;
			list-style: none;
			// width: 970px;
			flex-wrap: wrap;
			margin: 0 auto;
			padding: inherit;
			text-align: left;
			color: #222;
			padding: 0 15px;
			justify-content: space-between;

			.manage_item {
				width: 49%;
				// padding: 0 20px;
				margin-top: 20px;
				text-align: center;

				.teamImg {
					width: 100%;
					// height: auto;
					height: 180px;
				}

				.manageName {
					font-size: 18px;
					margin-top: 15px;
					font-weight: bold;
					font-family: 'zxhjt';
					font-style: oblique;
					text-align: left;
				}

				.manageJob {
					margin-top: 10px;
					text-align: left;
				}

				img {
					width: 100%;
					height: auto;
					border-radius: 10px;

				}
			}
		}

		.honor_view {
			// background: url('../../static/img/about/gg_bg.png') no-repeat;
			width: 100%;
			height: auto;
			// background-size: 100% auto;
			// background-position: center center;
			padding: 30px 15px;
			// padding-top: 84px;
			// padding-bottom: 70px;
			margin-top: 20px;
			background-color: #fbfbfb;

			.honorList {
				display: flex;
				width: 100%;
				// max-width: 1440px;
				flex-wrap: wrap;
				margin: 0 auto;
				margin-top: 20px;
				padding: inherit;
				text-align: center;
				color: #222;
				justify-content: space-between;
				// padding: 0 15px;
			}

			.honor_item {
				width: 49%;
				/* margin-top: 20px; */
				// margin-right: 104px;

				.honorText {
					margin-top: 13px;
					font-size: 12px;
				}

				.honorImg {
					width: 100%;
					height: 127px;
					// margin-top: 20px;
					border: 2px solid #DAC870;
					padding: 3px;
				}

			}

		}

		.active {
			border-bottom: 2px solid #0C8C69;
			color: #0C8C69;
			// font-weight: bold;
		}

		.history_view {
			background: url('../../static/img/about/yearImg1.png') no-repeat;
			width: 100%;
			height: auto;
			background-size: 100% auto;
			background-position: center center;
			padding: 45px 0;
			margin-top: 40px;

			.year_view {
				flex-direction: row;
				display: flex;
				align-items: center;
				margin: 0 35px;
				color: #fff;
				margin-top: 20px;
				overflow-x: auto;
				justify-content: space-between;
				font-size: 12px;

				.year_item {
					margin: 0 15px;
				}
			}

			.xian {
				width: 100%;
				max-width: 305px;
				height: 3px;
				background-color: rgba(239, 239, 239, 0.5);
				position: absolute;
				left: 50%;
				margin-left: -152px;
				margin-top: 27px;
				z-index: 1;
			}

			.content_list {
				font-size: 12px;
				color: #fff;
				/* width: 100%; */
				/* max-width: 900px; */
				border-radius: 10px;
				background: rgba(0, 0, 0, 0.4);
				height: 405px;
				/* overflow-y: auto; */
				padding: 30px;
				margin: 0 35px;
				margin-top: 37px;

				.content_xq {
					height: 345px;
					overflow-y: auto;
				}

				.content_item {
					display: flex;
					flex-direction: row;
					text-align: left;
					margin-bottom: 25px;
				}
			}
		}
		.live_view {
			.title_text {
				text-align: left;
				margin-left: 20px;
			}
		}
		.live_box {
			margin-top: 20px;

			.live_item {
				flex: 1;
				position: relative;

				.point {
					position: absolute;
					top: 50%;
					left: 50%;
					margin-left: -44px;
					margin-top: -16px;
					animation: zoom 1s infinite ease-in-out;
					-webkit-animation: zoom 1s infinite ease-in-out;
				}

				@keyframes zoom {
					0% {
						transform: scale(1);
					}

					50% {
						transform: scale(1.1);
					}

					100% {
						transform: scale(1);
					}
				}
			}
		}
	}

	.mianbao_item {
		margin: 0 20px;
		cursor: pointer;
		padding-bottom: 15px;
	}

	.active {
		border-bottom: 2px solid #0C8C69;
		// font-weight: bold;
	}

	@media (min-width: 768px) {
		.about_view {
			margin: 40px auto;
			font-size: 14px;
			width: 100%;
			max-width: 1440px;
			margin-top: 40px;
		}

		.vision_view1 {
			display: none;
		}

		.vision_view {
			width: 100%;
			// height: 740px;
			max-width: 1440px;
			margin: 0 auto;
			margin-top: 150px;
			margin-bottom: 40px;

			img {
				width: 100%;
				height: auto;
			}
		}

		.content_xq::-webkit-scrollbar {
			border-radius: 10px;
			width: 10px;
			height: 10px;
			background-color: #ffff;
			display: block !important;
		}

		::-webkit-scrollbar-thumb {
			border-radius: 10px;
			/* -webkit-box-shadow: inset 0 0 6px #c4aae4; */
			height: 10px;
			background-color: #fff;
		}

		::-webkit-scrollbar-track {
			/* -webkit-box-shadow: inset 0 0 6px #fff; */
			border-radius: 10px;
			background-color: #ccc;
		}

	}
</style>


// WEBPACK FOOTER //
// src/page/about.vue